export default {
  init: function () {
    return this.xf['@@transducer/init']();
  },
  result: function (result) {
    return this.xf['@@transducer/result'](result);
  }
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/ramda/es/internal/_xfBase.js
// module id = 4
// module chunks = 0